<template>
  <div class="creditcard-method">
    <div v-if="!addingCard">
      <p class="subtitle">
        Please select a saved credit card payment method or add a new credit card payment.
      </p>
      <div
        v-if="loading"
        class="loading"
      >
        <Loader />
        <span>Loading saved credit cards...</span>
      </div>
      <ul
        v-if="!loading"
        class="cards"
      >
        <li
          v-for="(card, index) in cards"
          :key="index"
          class="credit-card"
          :class="selectedCard && selectedCard.id === card.id && 'selected'"
          @click="$emit('selectCard', card)"
        >
          <img
            v-if="card.brand === 'Visa'"
            :src="VisaLogo"
          >
          <img
            v-if="card.brand === 'MasterCard'"
            :src="MastercardLogo"
          >
          <span>Ending in: {{ card.last4 }}</span>
        </li>
      </ul>
      <Button
        v-if="!loading"
        color="primary"
        plain
        @click="onAddCreditCard"
      >
        <div class="credit-card add-new-card">
          <span class="plus-icon"><img :src="AddIcon"></span>
          <span>Add new credit card</span>
        </div>
      </Button>
    </div>
    <NewCardDetails
      v-if="addingCard"
      @back="onGoBack"
      @add-new-card="addNewCard"
    />
  </div>
</template>

<script>
import axios from 'axios';
import Button from '../ui/Button.vue';
import NewCardDetails from './NewCardDetails.vue';
import AddIcon from '../../../public/add.svg';
import VisaLogo from '../../../public/visa.svg';
import MastercardLogo from '../../../public/mastercard.svg';
// eslint-disable-next-line
import Loader from '../../../public/loading.svg?inline';

export default {
  name: 'CreditCardMethod',
  components: {
    Button,
    NewCardDetails,
    Loader,
  },
  props: {
    selectedCard: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      addingCard: false,
      loading: true,
      cards: [],
      VisaLogo,
      MastercardLogo,
      AddIcon,
    };
  },
  created() {
    this.fetchCards();
  },
  methods: {
    addNewCard(newCard) {
      this.cards.push(newCard);
      this.$emit('selectCard', newCard);
      this.addingCard = false;
    },
    onAddCreditCard() {
      this.addingCard = true;
    },
    onGoBack() {
      this.addingCard = false;
    },
    fetchCards() {
      const plansUrl = `${process.env.VUE_APP_DJ_BASE_URL}api/cart/stripecards/?format=json`;

      this.loading = true;
      axios
        .get(plansUrl, { withCredentials: true })
        .then((response) => {
          const { data } = response;

          this.cards = data;

          if (!this.selectedCard) {
            const defaultCard = this.cards.find((card) => card.is_default);

            if (defaultCard) {
              this.$emit('selectCard', defaultCard);
            }
          }

          this.loading = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../variables.scss";

.loading {
  svg {
    width: 16px;
    height: 16px;
    vertical-align: middle;
    animation: .75s rotate360 infinite linear;
    margin-right: 5px;
  }
  font-size: 14px;
}

.creditcard-method {
  margin: 30px 0 0;
  padding: 5px 0 0;
  border-top: 1px solid #e5e5e9;
}

.subtitle {
  font-size: 14px;
}

.cards {
  display: flex;
  margin: 0 0 20px;
  padding: 0;
  list-style: none;
  flex-flow: row wrap;
}

// TODO: We style these boxes similar in several places,
// we should either make a UI component for them or move a base classe to a sass file
.credit-card {
  border: 1px solid #e5e5e9;
  border-radius: 3px;
  color: $primary-color;
  font-weight: bold;
  padding: 15px 10px;
  margin: 15px 15px 0px 0px;
  cursor: pointer;
  width: 300px;
  display: flex;
  align-items: center;
  height: 55px;

  img {
    align-self: end;
    height: 24px;
    margin-right: 5px;
  }

  &.selected {
    border: 1px solid $primary-color;
    background: rgba($primary-color, 0.05);
  }
}

.add-new-card:hover {
  border: 1px solid $primary-color;
  background: rgba($primary-color, 0.05);
}

.plus-icon {
  width: 20px;
  margin-right: 10px;
  margin-left: 8px;
  img {
    height: 14px;
  }
}

@media screen and (max-width: $license-modal-mobile) {
  .creditcard-method {
    border-top: none;
    margin-top: 15px;
  }
  .cards {
    flex-flow: column nowrap;
    margin-bottom: 0;
  }
  .credit-card {
    font-size: 12px;
    padding: 10px 5px;
    margin: 5px 0;
    height: 45px;
    width: 250px;

    &.add-new-card {
      padding-top: 12px;
    }
  }
}
</style>
